import { z } from 'zod';
import { componentExtrasSchema } from './component-extras.js';
import { groupChoicesSchema } from './group-choices.js';
import { lineSplitsSchema } from './line-splits.js';
import { outOfRangeTicketIndexMessage } from './out-of-range-ticket-index-message.js';
export const issueManufacturingOrderInputSchema = z
    .object({
    groupChoices: groupChoicesSchema,
    // Optional, unlike groupChoices: a release that answers no option group still had to decide to
    // take every default, where a release that splits no line simply has nothing to say. Absent and
    // [] mean the same thing, matching how ManufacturingOrderLineInput.splitQuantities already
    // normalises a cleared split.
    lineSplits: lineSplitsSchema.optional().default([]),
    // Absent and [] both mean the recipe amount alone, which is what every release meant before.
    componentExtras: componentExtrasSchema.optional(),
})
    .superRefine((val, ctx) => {
    const ticketCountByLine = new Map(val.lineSplits.map((split) => [split.manufacturingOrderItemId, split.tickets.length]));
    for (const choice of val.groupChoices) {
        if (choice.ticketIndex === undefined)
            continue;
        const ticketCount = ticketCountByLine.get(choice.manufacturingOrderItemId);
        // The resolver's authoritative check owns ticketIndex validation for lines absent from lineSplits.
        if (ticketCount === undefined)
            continue;
        if (choice.ticketIndex >= ticketCount) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: outOfRangeTicketIndexMessage(choice.ticketIndex, ticketCount),
                path: ['groupChoices'],
            });
        }
    }
});
//# sourceMappingURL=issue-input.js.map